<section class="video-upload-container">
  @if (!store.isUploadingAll() && !store.uploadFinished()) {
  <app-video-upload [filterValues]="filters" [seasons]="seasons">
    <app-video-query-elements [allowEmptyValues]="true" [(queryElementsConfig)]="queryElementsConfig"
      [(filters)]="filters">
      <div app-video-category-selector-extra *ngIf="filters?.category === 'other'">
        <div class="extra-input">
          <input type="text" class="input" placeholder="Escribe el nombre de la nueva categoría"
            [(ngModel)]="otherCategory" />
        </div>
      </div>
      <div app-video-competition-selector-extra *ngIf="filters?.competition === 'other'">
        <div class="extra-input">
          <input type="text" class="input" placeholder="Escribe el nombre de la nueva competición"
            [(ngModel)]="otherCompetition" />
        </div>
      </div>
    </app-video-query-elements>
  </app-video-upload>
  }

  @if (store.totalVideos() > 0) {

  <div class="queue-container">

    @if (store.isUploadingAll()) {
    <div class="upload-banner">
      <mat-icon>info</mat-icon>
      <span>Por favor, no cierres esta pestaña hasta que todos los videos finalicen de procesarse.</span>
    </div>
    }

    <h3><mat-icon>video_library</mat-icon> Videos en Cola</h3>

    <div class="video-grid">
      @for (video of store.videos(); track video.id) {
      <div class="video-card status-{{video.uploadStatus}}">
        <div class="video-card-header">
          <h4 [title]="video.title">{{video.title}}</h4>
          @if (!store.isUploadingAll() && !store.uploadFinished()) {
          <div class="actions">
            <button [disabled]="store.isUploadingAll()" (click)="editVideo(video.id)"
              title="Editar información"><mat-icon>edit</mat-icon></button>
            <button [disabled]="store.isUploadingAll()" (click)="removeVideo(video.id)" class="delete-btn"
              title="Eliminar de la lista"><mat-icon>delete</mat-icon></button>
          </div>
          }
        </div>

        <div class="video-card-body">
          <div class="file-name" [title]="video.file.name">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">movie</mat-icon>
            {{ video.file.name.length > 25 ? (video.file.name | slice:0:25) + '...' : video.file.name }}
          </div>

          @if (video.resolutionWidth && video.resolutionHeight) {
          <div class="resolution-badge">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">high_quality</mat-icon>
            {{video.resolutionWidth}}x{{video.resolutionHeight}}
          </div>
          }

          @if (!store.isUploadingAll() && !store.uploadFinished()) {
          <div class="filters">
            <span>{{video.gender}}</span>
            <span>{{video.category}}</span>
            <span>{{video.competition}}</span>
            <span>T{{video.seasonId || 1}}</span>
            <span>{{video.matchDate | date:'dd/MM/yyyy'}}</span>
          </div>
          }

          @if (video.uploadStatus === 'error' && video.errorMessage) {
          <div class="video-error-message">
            <mat-icon>warning</mat-icon>
            <span>{{ video.errorMessage }}</span>
          </div>
          }
        </div>

        <div class="video-card-footer">
          <div class="status-badge {{video.uploadStatus}}" [title]="video.errorMessage || ''">
            @switch (video.uploadStatus) {
            @case ('pending') { <mat-icon style="font-size: 16px; width: 16px; height: 16px;">schedule</mat-icon> Listo
            para subir }
            @case ('uploading') { <mat-icon style="font-size: 16px; width: 16px; height: 16px;">cloud_upload</mat-icon>
            Subiendo }
            @case ('processing') { <mat-icon style="font-size: 16px; width: 16px; height: 16px;">sync</mat-icon>
            Procesando }
            @case ('complete') { <mat-icon style="font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
            Completado }
            @case ('error') { <mat-icon style="font-size: 16px; width: 16px; height: 16px;">error</mat-icon> Error }
            }
          </div>

          @if (video.uploadStatus === 'uploading' || video.uploadStatus === 'processing') {
          <div class="mini-progress">
            <div class="mini-progress-track">
              <div class="mini-progress-fill" [style.width.%]="video.uploadProgress"></div>
            </div>
            <span class="mini-progress-percentage">{{ video.uploadProgress }}%</span>
          </div>
          } @else if (video.uploadStatus === 'complete') {
          <span style="font-size: 12px; color: #4CAF50;">100%</span>
          }
        </div>
      </div>
      }
    </div>

    @if (!store.isUploadingAll() && !store.uploadFinished()) {
    <div class="upload-action-panel">
      <div class="text-content">
        <h3>¿Todo listo?</h3>
        <p>Tienes {{store.pendingVideosCount()}} videos pendientes listos para subirse y procesarse.</p>
      </div>
      <button (click)="uploadAll()" [disabled]="!store.hasPendingVideos()" class="primary-button">
        <mat-icon>cloud_upload</mat-icon>
        Confirmar subida de {{ store.pendingVideosCount() }} videos
      </button>
    </div>
    }

    @if (store.uploadFinished()) {
    <div class="upload-action-panel"
      style="background: linear-gradient(135deg, #e4f5e9 0%, #c8e6d2 100%); border-color: #a3d9b4;">
      <div class="text-content">
        <h3 style="color: #2e7d32;"><mat-icon style="vertical-align: bottom;">check_circle</mat-icon> ¡Proceso
          Completado!</h3>
        <p style="color: #4caf50;">Todos los videos han sido procesados correctamente.</p>
      </div>
      <div style="display: flex; gap: 12px;">
        <button (click)="goToAnalysis()" class="primary-button"
          style="background: #2e7d32; box-shadow: 0 4px 12px rgba(46, 125, 50, 0.3);">
          <mat-icon>analytics</mat-icon>
          Ir al Panel de Análisis
        </button>
        <button (click)="uploadMore()" class="primary-button"
          style="background: white; color: #2e7d32; border: 1px solid #2e7d32; box-shadow: 0 4px 12px rgba(46, 125, 50, 0.1);">
          <mat-icon>add_to_queue</mat-icon>
          Subir más videos
        </button>
      </div>
    </div>
    }
  </div>
  }
</section>
